import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Card, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'
import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import DialogLoader from '../../../components/Loader/DialogLoader';
import { InputBaseField, CheckboxField, TextareaField } from '../../../components/InputField/InputField';
import { Label } from '../../../components/UiElements/UiElements'
import { GetUserInfo } from "../../../Services/GetUserInfo";
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "./../../../components/Message/Alert";
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress, validateEmail } from '../../../../src/components/Common/Extensions';
import profilePlaceholder from './../../../assets/img/profilePlaceholder.jpg';

import Logo from './../../../assets/img/app-login-logo.svg';

function LoginMultipleAccount({ dialogOpenClose, handleClose, handleMultipleAccountLoad, accounts, ...props }) {

    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [state, setSelectedAcount] = useState({})

    const handleAccountClick = (item) => {
        setSelectedAcount(item);
        handleMultipleAccountLoad(item);
    }

    const userAccounts = [
        {
            photo_path: profilePlaceholder,
        }
    ]

    const continueLogin = () => {
        handleMultipleAccountLoad(state);
    }

    useEffect(() => {
        console.log(accounts);
    }, []);
    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <img src={Logo} className={classes.logoArea} />
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div> 
                        
                        <hr></hr>

                        <div className={classes.content}>

                            <Grid container className={classes.selectHeading}>
                                <h2>Please select an account you are logging in</h2>
                            </Grid>

                            {accounts.length > 0 ?
                                <Grid container className={classes.addressBookBox} justifyContent="center">
                                    {
                                        accounts.map((item, i) => {
                                            return (
                                                <Grid item sm={6} xs={12} lg={6} md={6} className={classes.addressBox}>
                                                    <div className={classes.userContent} onClick={() => { handleAccountClick(item) }}>
                                                            <div className="user-address-Book">
                                                                <img className="user-address-Book" src={item.photo_path == null ? profilePlaceholder : '.' + item.photo_path} alt="user" />
                                                            </div>
                                                        <h3>{item.firstName}</h3>
                                                        <h4 >{item.accountNumber}</h4>
                                                        <h4 >{item.userType =='wireless_user'?'Wireless User':'Corporate User'}</h4>
                                                        <h4 className={"emailLink"}>{formateMdnNumber(item.phoneNumber)}</h4>
                                                          
                                                    </div>
                                                </Grid>)
                                        })
                                    }
                                </Grid> :
                                <Grid container className={classes.addressBookNoRecord}>
                                    <h3>No Account Exists.</h3>
                                </Grid>
                            }

                        </div>
{/* 
                        <div className={classes.footer}>
                            <div className={classes.footerCenter}>
                                <Button className={classes.changeBtn} onClick={continueLogin}>Continue</Button>

                            </div>
                        </div> */}

                    </div>
                </div>
            </Dialog>

        </>
    )
}

export default withSnackbar(LoginMultipleAccount);